<template>
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive">

			</router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive">

		</router-view>

	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {

			}
		},
		methods: {
			bodyScale() {
				var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可视区域宽度
				var scale = devicewidth / 1920; // 除以设计稿的尺寸
				document.body.style.zoom = scale; // 放大缩小相应倍数
			}
		},
		created() {
			this.bodyScale()
		}
	}
</script>

<style lang="scss">
	@import url('./assets/css/common.css');
	@import "./assets/css/common.scss";

	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		margin: 0;
		padding: 0;
		height: 100%;



	}

	a {
		text-decoration: none;
	}

	li {
		text-decoration: none;
		list-style: none;
	}

	.router-link-active {
		text-decoration: none;
	}

	.content {
		width: 1200px;
		margin: auto;

	}
</style>



// WEBPACK FOOTER //
// src/App.vue